import React from 'react'
import { useState, useEffect } from 'react';
import Searchbar2 from '../../components/forms/searchbar2';
import HelpFunctions from '../../functions/dashboard/help';
import { Link } from 'react-router-dom';
import Button from '../../components/forms/blackfillButton';
import ApiUrl from '../../configTools/apiUrl';
//import { useSearchParams } from 'react-router-dom';

const Tickets = () => {
    /*const [searchParams] = useSearchParams();
    if(searchParams.get('sort')){
        console.log(searchParams.get('sort'));
    }
    if(searchParams.get('brand')){
        console.log(searchParams.get('brand'));
    }*/
    const [Values,setValues] = useState([]);
    const [Filter,setFilter] = useState(Values);
    useEffect(()=>{
        HelpFunctions.Get(setValues)
    },[])
    useEffect(()=>{
        setFilter(Values);
    },[Values])
  return (
    <div className='form_table_container'>
      <Searchbar2 Values={Values} setFilter={setFilter}/>
      <table>
        <thead>
          <tr className='title'>
            <td className='form_item_row_container_itemfull' style={{width:'10%'}}>
              <p></p>
            </td>
            <td className='form_item_row_container_item' style={{width:'15%'}}>
              <p>User</p>
            </td>
            <td className='form_item_row_container_itemfull' style={{width:'10%'}}>
              <p>Ticket#</p>
            </td>
            <td className='form_item_row_container_item' style={{width:'15%'}}>
              <p>Subject</p>
            </td>
            <td className='form_item_row_container_item' style={{width:'35%'}}>
              <p>Message</p>
            </td>
            <td className='form_item_row_container_item' style={{width:'10%'}}>
              <p>Date</p>
            </td>
            <td className='form_item_row_container_item' style={{width:'5%'}}>
              <p></p>
            </td>
          </tr>
        </thead>
        <tbody>
        {
          Filter.map((item,Index)=>{
            return(
                <tr key={Index}>
                    <td className='form_item_row_container_item' style={{width:'10%'}}>
                    <div style={{
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "3px",
                        border: "2px solid black",
                        position:"relative"
                    }}>
                    </div>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'15%'}}>
                        <p>{item.username}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'10%'}}>
                        <p>TXK-2023-{item.id}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'15%'}}>
                        <p>{item.subject}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'35%'}}>
                        <p>{item.message}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'10%'}}>
                        <p>{item.date}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'5%'}}>
                        <Link to={'#'}>
                            <Button Value={'Email'} Action={
                                ()=>{
                                    window.location.href = 'mailto:'+item.email+'?subject=Ticket #TXK-2023-'+item.id;
                                }
                            } />
                        </Link>
                    </td>
                </tr>
            );
          })
        }
        </tbody>
      </table>
    </div>
  )
}

export default Tickets
